<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        apiBodyMeasures.length > 0 ? 'selected' : ''
      ]"
      @click="fieldData.showTargetGroupModal = true"
    >
      Target / Metric   
    </button>

    <b-modal
      v-model="fieldData.showTargetGroupModal"
      dialog-class="targetgroupmodal"
      scrollable
      title="Select target group / metric"
      @hidden="cancelTargetGroups"
      @ok="saveTargetGroups"
      @show="showTargetModal"
    >
      <b-form-row>
        <b-col sm="6">
          <label for="group-selection">Target group</label>
          <b-form-select
            id="group-selection"
            v-model="form.group.selected"
            :options="form.group.options"
            size="sm"
          />
        </b-col>

        <b-col
          sm="6"
          class="mb-2"
        >
          <label for="measurements-selection">Metric</label>
          <b-form-select
            id="measurements-selection"
            v-model="fieldData.measurements.selected"
            :options="fieldData.measurements.options"
            size="sm"
          />
        </b-col>
        <b-col sm="4">
          <label for="age-from-selection">Age from</label>
          <b-form-select
            id="age-from-selection"
            v-model="form.age.from.selected"
            size="sm"
          >
            <option
              v-for="ageFrom in form.age.from.options"
              :key="ageFrom.value"
              :disabled="ageFrom.value < form.age.to.selected ? false : true"
              :value="ageFrom.value"
            >
              {{ ageFrom.text }}
            </option>
          </b-form-select>
        </b-col>

        <b-col sm="4">
          <label for="age-to-selection">Age to</label>
          <b-form-select
            id="age-to-selection"
            v-model="form.age.to.selected"
            size="sm"
          >
            <option
              v-for="ageTo in form.age.to.options"
              :key="ageTo.value"
              :disabled="ageTo.value > form.age.from.selected ? false : true"
              :value="ageTo.value"
            >
              {{ ageTo.text }}
            </option>
          </b-form-select>
        </b-col>
        <b-col sm="4">
          <label for="age-to-selection">Reach criteria</label>
          <b-form-select
            id="reach-target-group"
            v-model="selectedReachCriteria"
            :disabled="isReachCriteriaDisabled"
            :options="reachCriteriaOptions"
            size="sm"
          />
        </b-col>
      </b-form-row>
      <b-form-row class="mt-3 mb-2">
        <b-col cols="12">
          <b-button
            class="mr-2"
            variant="success"
            size="sm"
            @click="add"
          >
            Add          
          </b-button>
          <b-button
            v-if="measuresSite.length > 1"
            class="mr-2"
            variant="danger"
            size="sm"
            @click="deleteAllSelections"
          >
            Remove all
          </b-button>
        </b-col>
      </b-form-row>
      <b-list-group class="mt-3">
        <b-list-group-item
          v-for="(measureSite, index) in measuresSite"
          :key="index"
        >
          <span>{{ measureSite.measure_name }}</span>
          <b-button
            class="mr-2 float-right"
            variant="danger"
            size="sm"
            @click="deleteSelection(index)"
          >
            Remove
          </b-button>
        </b-list-group-item>
      </b-list-group>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="ok()"
        >
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { fetchFormFieldData } from '../../../assets/js/api.js';
import globalConfig from "../../../mixins/globalConfig.js"
export default {
  name: 'TargetGroupSiteModal',
  mixins: [globalConfig],
  props: {
    fieldData: Object,
  },
  data() {
    return {
      maxTargetgroups: 8,
      selectedReachCriteria: 15,
      reachCriteriaOptions: [
        { value: 1, text: '1 sec', selectedReachCriteriaText: '1 sec' },
        { value: 2, text: '2 sec', selectedReachCriteriaText: '2 sec' },
        { value: 5, text: '5 sec', selectedReachCriteriaText: '5 sec' },
        { value: 10, text: '10 sec', selectedReachCriteriaText: '10 sec' },
        { value: 15, text: '15 sec or 50% of length', selectedReachCriteriaText: '15 sec/50%' },
        { value: 20, text: '20 sec', selectedReachCriteriaText: '20 sec' },
        { value: 30, text: '30 sec', selectedReachCriteriaText: '30 sec' },
        { value: 60, text: '60 sec', selectedReachCriteriaText: '60 sec' },
        { value: 120, text: '120 sec', selectedReachCriteriaText: '120 sec' },
        { value: 180, text: '180 sec', selectedReachCriteriaText: '180 sec' },
      ],
      measuresSite: [],
      hasChange: false,
      form: {
        group: {
          selected: 'Alla',
          options: [
            { value: 'Alla', text: 'All' },
            { value: 'Kvinnor', text: 'Women' },
            { value: 'Män', text: 'Men' },
          ],
        },
        age: {
          from: {
            selected: 3,
            options: [],
          },
          to: {
            selected: 99,
            options: [],
          },
        },
      },
    };
  },
  beforeDestroy() {
    // Clean up by removing the event listener when the component is destroyed
    document.removeEventListener("keyup", this.onKeyUp);
  },
  computed: {
    isReachCriteriaDisabled() {
      let visibleReachSelectors = [
        ...this.fieldData.measurements.options.filter((measure) => measure.showReachSelector),
      ].map((m) => m.value);
      return !visibleReachSelectors.includes(this.fieldData.measurements.selected);
    },
    isReachSelected() {
      let isReachSelected = !this.isReachCriteriaDisabled;
      return isReachSelected;
    },
    apiBodyMeasures() {
      let apiBodyMeasures = this.$store.getters['siteApiBody/getPayload'].measures;
      return apiBodyMeasures 
    }
  },
  async created() {
      this.setupTargetGrups();

      let measureSiteNames = [];
      for (let i = 0; i < this.measuresSite.length; i++) {
        measureSiteNames.push(this.measuresSite[i].measure_name);
      }
      let reachMeasureSiteNames = [];
      for (let i = 0; i < this.measuresSite.length; i++) {
        reachMeasureSiteNames.push(this.measuresSite[i].measure_name);
      }
      this.$store.commit('targetGroups/defineSiteSearchTargetGroups', measureSiteNames);
      this.$store.commit('targetGroups/defineSiteReachTargetGroups', reachMeasureSiteNames);
    },
  methods: {
    showTargetModal() {
      this.measuresSite = JSON.parse(JSON.stringify(this.apiBodyMeasures));
      document.addEventListener("keyup", this.onKeyUp);
    },
    deleteSelection(index) {
      this.measuresSite.splice(index, 1);
    },
    async setupTargetGrups() {
      let targetGroups = await fetchFormFieldData('TargetGroups');

      if (targetGroups.statusCode) {
        this.$bvToast.toast(targetGroups.errorMessage, {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      }

      this.form.age.from.options = [];
      let uniqueTargetGoups = targetGroups.filter(function(obj) {
        return obj.gender === 'Man';
      });

      for (let index in uniqueTargetGoups) {
        this.form.age.from.options.push({
          value: uniqueTargetGoups[index].age_from,
          text: uniqueTargetGoups[index].age_from,
        });
        this.form.age.to.options.push({
          value: uniqueTargetGoups[index].age_to,
          text: uniqueTargetGoups[index].age_to,
        });
      }
    },
    add() {
      document.activeElement.blur()
      let maxTargetGroupCount;
      if (Number.isInteger(this.config_NumberOfTargetGroupsChannel)) maxTargetGroupCount = this.config_NumberOfTargetGroupsChannel
      else maxTargetGroupCount = 8
      if (this.measuresSite.length >= maxTargetGroupCount) {
        this.$bvToast.toast('Max antal målgrupper är ' + maxTargetGroupCount, {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        this.addTargetGroupSite();
      }
    },
    addTargetGroupSite() {
      let min_viewing_time = 0;
      let gender = this.form.group.options.find(g => g.value == this.form.group.selected).text.charAt(0)
      let measurement = this.fieldData.measurements.selected;
      this.fieldData.measurements.options.forEach((element) => {
        if (element.value == this.fieldData.measurements.selected) {
          measurement = element.text;
        }
      });
      let ageFrom = this.form.age.from.selected;
      let ageTo = this.form.age.to.selected;
      let targetGroupString = `${measurement} ${gender}${ageFrom}-${ageTo}`;

      if (this.isReachSelected) {
        min_viewing_time = this.selectedReachCriteria;
        let selectedReachCriteriaText = this.reachCriteriaOptions.filter(function(reachCriteria) {
          if (reachCriteria.value === this) return reachCriteria;
        }, this.selectedReachCriteria)[0].selectedReachCriteriaText;
        targetGroupString = `${targetGroupString}, ${selectedReachCriteriaText}`;
      }
      if (this.measuresSite.some((e) => e.measure_name === targetGroupString)) {
        this.$bvToast.toast('Targetgroup already exist', {
          title: 'Warning',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000,
        });
      } else {
        this.updateMeasuresForSearch(targetGroupString, min_viewing_time);
      }
    },
    updateMeasuresForSearch(measureName, min_viewing_time) {
      let measure = {
        measure_type: this.fieldData.measurements.selected,
        target_group_keys: this.getTargetGroupKeys(),
        min_viewing_time,
        measure_name: measureName,
        isReach: this.isReachSelected,
        reachAbsHeader: `Reach indv ${measureName.match(/\(([^)]+)\)/)[0]}`,
        reachRelHeader: `Reach % ${measureName.match(/\(([^)]+)\)/)[0]}`,
        ageGroup: `${this.form.group.selected.charAt(0)}${this.form.age.from.selected}-${
          this.form.age.to.selected
        }`,
      };
      this.measuresSite.push(measure);
    },
    getTargetGroupKeys() {
      let target_group_keys = [];
      this.form.age.to.options.forEach((age) => {
        if (age.value <= this.form.age.to.selected && age.value > this.form.age.from.selected) {
          if (this.form.group.selected === 'Kvinnor' || this.form.group.selected === 'Alla') {
            target_group_keys.push('female_age' + age.value);
          }
          if (this.form.group.selected === 'Män' || this.form.group.selected === 'Alla') {
            target_group_keys.push('male_age' + age.value);
          }
        }
      });
      return target_group_keys;
    },
    deleteAllSelections() {
      this.measuresSite = [];
    },
    cancelTargetGroups() {
      this.measuresSite = _.cloneDeep(this.$store.state.siteApiBody.payload.measures);
    },
    // in TargetGroupSiteModal.vue
    saveTargetGroups() {
      
      const measuresForSite = _.cloneDeep(this.measuresSite);
      const measuresForReach = _.cloneDeep(this.measuresSite);
      this.$store.commit('siteApiBody/updateMeasures', measuresForSite);
      this.$store.commit('siteReachApiBody/updateMeasures', measuresForReach);

      const measureSiteNames = this.measuresSite.map(m => m.measure_name);
      this.$store.commit('targetGroups/defineSiteSearchTargetGroups', measureSiteNames);

      if (this.measuresSite.length === 0) {
        this.$emit('onGoToListTab');
      }
    },
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showTargetGroupModal) {
        this.saveTargetGroups()   
        this.fieldData.showTargetGroupModal = false;
      }
    },
  },
};
</script>
